import { Component, forwardRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Select } from 'primeng/select';
import { InputBaseComponent } from '../input-base/input-base.component';
import { merge, of } from 'rxjs';
import { InputDropdownItemModel } from './input-dropdown-item.model';
import { InputAutocomplete } from '../enums';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-dropdown',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss'],
  providers: [{ provide: InputBaseComponent, useExisting: forwardRef(() => InputDropdownComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputDropdownComponent extends InputBaseComponent implements OnInit, OnChanges {

  @Input() public autocomplete: InputAutocomplete | string = InputAutocomplete.Off; // TODO
  @Input() public appendTo?: unknown = 'body';
  @Input() public minItemsForFilter: number | false = 10;    // false = do not show filter
  @Input() public pleaseSelectLabel?: string;
  @Input() public items: InputDropdownItemModel<any, any>[] = [];
  @Input() public translateItems: boolean = true;
  @Input() public editable: boolean = false; // enables writing own text
  @Input() public placeholder?: string;
  @Input() public dropdownIcon: string = 'fa fa-fw fa-caret-down';
  @Input() public dropdownIconWhenOpened: string = 'fa fa-fw fa-caret-up';

  // PrimeNG 22 made dropdownIcon a signal input, so the open/closed icon is held here.
  public currentDropdownIcon: string = this.dropdownIcon;

  @Output() public onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onBlur: EventEmitter<any> = new EventEmitter<any>();

  public itemsForTemplate: InputDropdownItemModel<any, any>[] = [];
  public selectedItem?: InputDropdownItemModel<any, any> | null;

  @ViewChild('dropdown') private elRef?: Select;

  constructor(private translateService: TranslateService) {
    super();
  }

  // TODO merge duplicate code with input-multiselect - helpermethod?
  public override ngOnInit(): void {
    super.ngOnInit();
    this.setItems();
    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.setItems());
    merge(of(this.control.value), this.change)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((val) => {
        this.selectedItem = this.items ? this.items.find((p) => p.value === val) : null;
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] || changes['includePleaseSelect']) {
      this.setItems();
    }
  }

  public openDropdown(event: Event): void {
    event.stopPropagation();
    if (this.elRef) {
      this.elRef.show();
    }
  }

  // TODO merge duplicate code with input-multiselect - helpermethod?
  private setItems(): void {
    // v18: translations moved behind getTranslations() and currentLang became a signal.
    const currentLang = this.translateService.currentLang();
    const translation = currentLang ? this.translateService.getTranslations(currentLang) as any : undefined;
    if (!translation) {
      return;
    }
    const items = this.translateItems
      ? this.items.map((i) => {
        const path = i.label.split('.').reverse();
        let part = path.pop() as string;
        let translatedLabel = translation[part];
        while (path.length && translatedLabel) {
          part = path.pop() as string;
          translatedLabel = translatedLabel[part];
        }
        return ({ value: i.value, label: translatedLabel ?? this.translateService.instant(i.label), disabled: !i.disabled ? false : i.disabled });
      })
      : this.items;

    if (this.pleaseSelectLabel?.length) {
      this.itemsForTemplate = [
        { value: null, label: this.pleaseSelectLabel, disabled: true },
        ...items
      ];
    }
    else {
      this.itemsForTemplate = items;
    }

  }

}
